import type {Logger} from './baseLogger.js';
import {createConsoleLogger} from './baseLogger.js';

export let logger = createConsoleLogger();
export const setLogger = (newLogger: Logger) => {
    logger = newLogger;
};
